interface SpriteConfig {
    id: string;
    width: number;
    height: number;
}

const SPRITES: Record<string, SpriteConfig> = {
    guerrero: { id: 'ironknightarmor', width: 32, height: 32 },
    mago: { id: 'blackwizard', width: 48, height: 48 },
    arquero: { id: 'archerarmor', width: 32, height: 32 }
};

const IDLE_ROW = 8;
const IDLE_FRAMES = 2;
const DISPLAY_SIZE = 128;

export default class CharacterSelect {
    private screen: HTMLElement;
    private selectedClass = 'guerrero';
    private intervals: ReturnType<typeof setInterval>[] = [];

    public constructor(
        private onCreate: (cls: string, user: string, pass: string, confirm: string) => void
    ) {
        this.screen = document.querySelector('#char-creation-screen')!;

        for (let cls of Object.keys(SPRITES)) {
            document.querySelector(`#ccs-${cls}`)?.addEventListener('click', () =>
                this.selectClass(cls)
            );
        }

        document.querySelector('#ccs-create')?.addEventListener('click', () => this.handleCreate());
        document.querySelector('#ccs-cancel')?.addEventListener('click', () => this.hide());

        for (let id of ['ccs-username', 'ccs-password', 'ccs-confirm']) {
            document.querySelector(`#${id}`)?.addEventListener('keydown', (e: Event) => {
                if ((e as KeyboardEvent).key === 'Enter') this.handleCreate();
            });
        }

        this.selectClass('guerrero');
    }

    private selectClass(cls: string): void {
        this.selectedClass = cls;
        document.querySelectorAll('.ccs-card').forEach((c) => c.classList.remove('selected'));
        document.querySelector(`#ccs-${cls}`)?.classList.add('selected');
    }

    public show(): void {
        this.screen.style.display = 'flex';
        this.clearError();
        this.clearInputs();
        this.startAnimations();
        setTimeout(() => (document.querySelector('#ccs-username') as HTMLInputElement)?.focus(), 80);
    }

    public hide(): void {
        this.screen.style.display = 'none';
        this.stopAnimations();
    }

    public showError(msg: string): void {
        let el = document.querySelector('#ccs-error') as HTMLElement;
        if (el) {
            el.textContent = msg;
            el.style.display = 'block';
        }
    }

    private clearError(): void {
        let el = document.querySelector('#ccs-error') as HTMLElement;
        if (el) {
            el.textContent = '';
            el.style.display = 'none';
        }
    }

    private clearInputs(): void {
        for (let id of ['ccs-username', 'ccs-password', 'ccs-confirm']) {
            let el = document.querySelector(`#${id}`) as HTMLInputElement;
            if (el) el.value = '';
        }
    }

    private handleCreate(): void {
        let user = (document.querySelector('#ccs-username') as HTMLInputElement)?.value.trim() ?? '';
        let pass = (document.querySelector('#ccs-password') as HTMLInputElement)?.value ?? '';
        let confirm = (document.querySelector('#ccs-confirm') as HTMLInputElement)?.value ?? '';

        this.clearError();

        if (!user) { this.showError('Por favor ingresa un nombre de personaje.'); return; }
        if (!pass) { this.showError('Por favor ingresa una contraseña.'); return; }
        if (pass.length < 3) { this.showError('La contraseña debe tener al menos 3 caracteres.'); return; }
        if (pass !== confirm) { this.showError('Las contraseñas no coinciden.'); return; }

        this.hide();
        this.onCreate(this.selectedClass, user, pass, confirm);
    }

    private startAnimations(): void {
        this.stopAnimations();

        for (let [cls, cfg] of Object.entries(SPRITES)) {
            let canvas = document.querySelector<HTMLCanvasElement>(`#ccs-${cls} .ccs-canvas`);
            if (!canvas) continue;

            let ctx = canvas.getContext('2d')!;
            ctx.imageSmoothingEnabled = false;

            let img = new Image();
            img.src = `/img/sprites/${cfg.id}.png`;

            let frame = 0;
            let scale = DISPLAY_SIZE / cfg.width;
            let dh = cfg.height * scale;
            let dy = Math.floor((DISPLAY_SIZE - dh) / 2);

            let draw = () => {
                ctx.clearRect(0, 0, DISPLAY_SIZE, DISPLAY_SIZE);
                if (!img.complete || !img.naturalHeight) return;
                ctx.imageSmoothingEnabled = false;
                ctx.drawImage(
                    img,
                    frame * cfg.width,
                    IDLE_ROW * cfg.height,
                    cfg.width,
                    cfg.height,
                    0,
                    dy,
                    DISPLAY_SIZE,
                    dh
                );
            };

            img.onload = () => draw();

            let id = setInterval(() => {
                frame = (frame + 1) % IDLE_FRAMES;
                draw();
            }, 600);

            this.intervals.push(id);
        }
    }

    private stopAnimations(): void {
        for (let id of this.intervals) clearInterval(id);
        this.intervals = [];
    }
}
